/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timelineempty1Inputs */

const en_timelineempty1 = /** @type {(inputs: Timelineempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The timeline is empty.`)
};

const pt_timelineempty1 = /** @type {(inputs: Timelineempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cronologia está vazia.`)
};

/**
* | output |
* | --- |
* | "The timeline is empty." |
*
* @param {Timelineempty1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const timelineempty1 = /** @type {((inputs?: Timelineempty1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timelineempty1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_timelineempty1(inputs)
	return pt_timelineempty1(inputs)
});
export { timelineempty1 as "timelineEmpty" }